import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';
import { Badge, Text } from '@mantine/core';
import { BadgeListItem } from '@dealstack/frontend/app/pages/Valuations/components/OverflowBadgeList/OverflowBadgeList.utils.types';

interface Props {
	badge: BadgeListItem;
}

export const StandaloneBadge = ({ badge }: Props) => {
	return (
		<Badge
			size="xl"
			variant={badge.selected ? 'light' : 'outline'}
			color={badge.selected ? 'blue.4' : 'gray.4'}
			onClick={badge.onBadgeClick}
			styles={{
				root: {
					height: 'auto',
					fontVariantNumeric: 'normal',
					padding: 'calc(0.5rem / 3) 0.5rem',
					cursor: badge.onBadgeClick ? 'pointer' : 'auto',
					lineHeight: 'normal',
					transition: 'background 0.3s ease',
					'&:hover': {
						backgroundColor: defaultTheme.v2.color.neutral[200],
					},
				},
				label: {
					display: 'inline-flex',
					alignItems: 'center',
					overflow: 'visible',
					fontVariantNumeric: 'normal',
					color: defaultTheme.v2.color.neutral[900],
				},
			}}
		>
			<Text fz="sm" fw={400}>
				{badge.label}
			</Text>
		</Badge>
	);
};
